// Axios
import axios from "axios";
import dayjs from "dayjs";
import StatusService from "./statusService";
import {  } from "../getters"
const weekOfYear = require('dayjs/plugin/weekOfYear')
const weekYear = require('dayjs/plugin/weekYear')
dayjs.extend(weekOfYear)
dayjs.extend(weekYear)

class ShiftsService {

    constructor() {

        this.url = (process.env.NODE_ENV == 'development' || window.location.origin == 'https://informitalia-client-test.quattrolinee.com' || window.location.origin == 'https://informitalia-app-test.quattrolinee.com')
            ? 'https://informitalia-server-test.quattrolinee.com/api/v1/shifts/'
            : 'https://informitalia-server.quattrolinee.com/api/v1/shifts/'

    }


      /////////////////////////////////////////////
     // GET ALL SHIFTS ///////////////////////////
    /////////////////////////////////////////////

    async getShifts(token, year, weekNr, groupId) {

        const config = {
            maxBodyLength: Infinity,
            headers: {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        }

        return await axios.get(`${this.url}${year}/${weekNr}/${groupId}`, config)

        .then(function (response) {

            console.log('SHIFTS WEEK' + ' ' + weekNr + ': ', response.data.data)
            return response.data.data
        })

        .catch(function (error) {

            console.log(error)
            StatusService.unauthorized(error.response.status)
            return false
        })
    }

    async getShiftsAllWeek(token, year, weekNr) {

        const config = {
            maxBodyLength: Infinity,
            headers: {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        }

        return await axios.get(`${this.url}${year}/${weekNr}`, config)

            .then(function (response) {

                console.log('SHIFTS WEEK' + ' ' + weekNr + ': ', response.data.data)
                return response.data.data

            })

            .catch(function (error) {

                console.log(error)
                StatusService.unauthorized(error.response.status)
                return false
            })
    }

    //////////////////////////////////
    // FUNCTION TO CREATE SINGLE SHIFT
    //////////////////////////////////

    async createSingleShift(token, userData) {
        const config = {
            headers: {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + token,
            },
        }

        return await axios.post(this.url, userData, config)

            .then(function (response) {

                console.log(response.data.data.id)
                return response.data.data

            })

            .catch(function (error) {

                console.log(error)
                StatusService.unauthorized(error.response.status)
                return false
            })
    }

    //////////////////////////////////
    // FUNCTION TO CREATE SINGLE SHIFT
    //////////////////////////////////

    async updateSingleShift(token, id, userData) {
        const config = {
            headers: {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + token,
            },
        }

        await axios.put(this.url + id, userData, config)

            .then(function (response) {

                console.log(response.data.data)
                return response.data.data
            })

            .catch(function (error) {

                console.log(error)
                StatusService.unauthorized(error.response.status)
                return false
            })
    }

    ////////////////////////////////////////////////////
    // FUNCTION TO EDIT THE OBJECT OF A SCHEDULED SHIFT 
    ////////////////////////////////////////////////////

    editShifts(scheduleList, shop_id, date, time_start, time_end, user_name, id, target, message, shift_id) {

        for (var j = 0; j < scheduleList.length; j++) {

            if (shop_id == scheduleList[j].shop_id) {

                Array.from(scheduleList[j].shifts).map((currentShift) => {
                    if (dayjs(currentShift.date).format('DD-MM-YYYY') == date && target == 'morning') {

                        currentShift.morning.shift_id = shift_id
                        currentShift.morning.message = message
                        currentShift.morning.time_start = time_start.substring(0, 5)
                        currentShift.morning.time_end = time_end.substring(0, 5)
                        currentShift.morning.worker = user_name
                        currentShift.morning.id = id
                    }
                    if (dayjs(currentShift.date).format('DD-MM-YYYY') == date && target == 'afternoon') {

                        currentShift.afternoon.shift_id = shift_id
                        currentShift.afternoon.message = message
                        currentShift.afternoon.time_start = time_start.substring(0, 5)
                        currentShift.afternoon.time_end = time_end.substring(0, 5)
                        currentShift.afternoon.worker = user_name
                        currentShift.afternoon.id = id
                    }
                    if (dayjs(currentShift.date).format('DD-MM-YYYY') == date && target == 'evening') {

                        currentShift.evening.shift_id = shift_id
                        currentShift.evening.message = message
                        currentShift.evening.time_start = time_start.substring(0, 5)
                        currentShift.evening.time_end = time_end.substring(0, 5)
                        currentShift.evening.worker = user_name
                        currentShift.evening.id = id
                    }
                })
            }
        }

        return scheduleList
    }

    ////////////////////////////////////////////////////
    // FUNCTION TO DELETE THE OBJECT OF A SCHEDULED SHIFT 
    ////////////////////////////////////////////////////

    deleteDashboardShifts(scheduleList, shop_id, date, time_start, time_end, user_name, target) {

        for (var j = 0; j < scheduleList.length; j++) {

            if (shop_id == scheduleList[j].shop_id) {

                Array.from(scheduleList[j].shifts).map((currentShift) => {
                    if (dayjs(currentShift.date).format('DD-MM-YYYY') == date && target == 'morning') {

                        currentShift.morning.shift_id = null
                        currentShift.morning.message = null
                        currentShift.morning.time_start = null
                        currentShift.morning.time_end = null
                        currentShift.morning.worker = null
                        currentShift.morning.id = null
                    }
                    if (dayjs(currentShift.date).format('DD-MM-YYYY') == date && target == 'afternoon') {

                        currentShift.afternoon.shift_id = null
                        currentShift.afternoon.message = null
                        currentShift.afternoon.time_start = null
                        currentShift.afternoon.time_end = null
                        currentShift.afternoon.worker = null
                        currentShift.afternoon.id = null
                    }
                    if (dayjs(currentShift.date).format('DD-MM-YYYY') == date && target == 'evening') {

                        currentShift.evening.shift_id = null
                        currentShift.evening.message = null
                        currentShift.evening.time_start = null
                        currentShift.evening.time_end = null
                        currentShift.evening.worker = null
                        currentShift.evening.id = null
                    }
                })
            }
        }

        return scheduleList
    }

    ////////////////////////////////////
    // FUNCTION TO DELETE A SINGLE SHIFT 
    ////////////////////////////////////

    async deleteSingleShift(token, id) {
        const config = {
            headers: {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + token,
            },
        }
        

        await axios.delete(this.url + id, config)

            .then(function (response) {

                console.log('SHIFT DELETED', response.data.data)
                return response.data.data

            })

            .catch(function (error) {

                console.log(error)
                StatusService.unauthorized(error.response.status)
                return false
            })
    }

    //////////////////////
    // WORKERS CONSTRAINTS 
    //////////////////////

    async getSingleWorkerWeekTotHours(token, year, weekNr) {
        const allShifts = await this.getShiftsAllWeek(token, year, weekNr)
        var totHours = []
        var arrayIds = []

        Array.from(allShifts).map((shift) => {
            if(!arrayIds.includes(shift.user_id)){
                arrayIds.push(shift.user_id)
            }
        })
            
        arrayIds.map((id) => {
            totHours.push({
                user_id: id,
                tot_hours: 0,
                num_hours: null,
                status: 'less'
            })
        })

        totHours.map((worker) => {
            Array.from(allShifts).map((shift) => {
                if (worker.user_id == shift.user_id) {
                    worker.tot_hours += parseInt(shift.tot_hours)
                }
            })
        })

        return totHours

    }

    async getWorkerTotHours(token, year, weekNr, id){
        var info = await this.getSingleWorkerWeekTotHours(token, year, weekNr)
        var result = '';

        Array.from(info).map((hours) => {
            if(hours.user_id == id){
                result = hours.tot_hours
            }
        })

        return result
    }

    checkTotHours(workers, totHours) {

        Array.from(workers).map((worker) => {
            Array.from(totHours).map((hours) => {
                if (worker.id == hours.user_id) {
                    
                    if(workers.num_hours !== null){
                        hours.num_hours = worker.num_hours
                    }else{
                        hours.num_hours = null
                    }
                    hours.user_name = worker.full_name
                }
            })
        })

        Array.from(totHours).map((worker) => {
            if(worker.num_hours !== null){
                if (parseInt(worker.num_hours) == worker.tot_hours) {
                    worker.status = 'ok'
                } else if (worker.tot_hours > parseInt(worker.num_hours)) {
                    worker.status = 'more'
                } 
            } else {
                worker.status = 'Nessun monte ore'
            }
        })

        return totHours
    }

}

export default new ShiftsService();